import { Link } from "@tanstack/react-router";

import { useWaterSources } from "@/lib/api/water-sources";
import { Button } from "@/components/ui/button";
import { ErrorState } from "@/components/error-state";

export function ChemistryWaterSourcesPage() {
  const q = useWaterSources();
  const items = q.data?.items ?? [];
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-end">
        <Link to="/chemistry-profile/water-sources/new">
          <Button size="sm">New water source</Button>
        </Link>
      </div>
      {q.error && <ErrorState error={q.error} retry={q.refetch} />}
      {q.isLoading && (
        <p className="text-sm text-muted-foreground">Loading…</p>
      )}
      {q.data && items.length === 0 && (
        <p className="text-sm text-muted-foreground">
          No water sources recorded yet.
        </p>
      )}
      {items.length > 0 && (
        <ul className="divide-y rounded-md border">
          {items.map((w) => (
            <li key={w.id}>
              <Link
                to="/chemistry-profile/water-sources/$waterSourceId"
                params={{ waterSourceId: w.id }}
                className="block px-4 py-3 hover:bg-accent/50"
              >
                <div className="space-y-0.5">
                  <p className="font-medium">{w.name}</p>
                  <p className="text-xs text-muted-foreground">
                    pH {w.baseline_ph ?? "—"} · EC {w.baseline_ec ?? "—"} · alk{" "}
                    {w.alkalinity_estimate ?? "—"}
                  </p>
                  {w.notes && (
                    <p className="text-xs text-muted-foreground">{w.notes}</p>
                  )}
                </div>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
